import { combineReducers } from "redux";
import actionTypeReducer from "./actionTypeReducer";
import businessActivitiesReducer from "./business-activities-reducer";
import createTransactionResponseObjReducer from "./create-transaction-response-obj-reducer";
import dealerAccountDetailsReducer from "./dealer-account-details-reducer.js";
import domainReducer from "./domain-reducer.js";
import loadingReducer from "./loading-reducer";
import machineReducer from "./machine-reducer";
import onSubmitDetailsReducer from "./on-submit-details-reducer";
import paymentMethodReducer from "./payment-method-reducer.js";
import searchObjReducer from "./search-obj-reducer";
import setSearchPageComponentReducer from "./search-page-components-reducer";
import setSearchTxnAccountDropdownReducer from "./search-txn-account-dropdowns.js";
import searchTxnResponseReducer from "./search-txn-response-reducer.js";
import selectedAccordionReducer from "./selected-accordion-reducer.js";
import simulateModeReducer from "./simulate-mode-reducer.js";
import simulatedActivitiesReducer from "./simulated-activities-reducer.js";
import simulatedUserDetailsReducer from "./simulated-user-details-reducer.js";
import transactionBidsReducer from "./transaction-bid-reducer";
import transactionPaymentReducer from "./transaction-payment-reducer";
import transactionReducer from "./transaction-reducer";
import transactionRequestReducer from "./transaction-request-reducer";
import translatedTextsReducer from "./translated-texts-reducer";
import txnsForReviewCountReducer from "./txn-count-reducer";
import userDetailsReducer from "./user-detail-reducer";
import transactionAttachmentsReducer from "./transaction-attachments-reducer.js";
import transactionAttachmentResponseReducer from "./transaction-attachment-response-reducer..js";
import transactionStatusReducer from "./transaction-status-reducer.js";
import relatedAccountReducer from "./related-account-reducer.js";

export default combineReducers({
  domainDetails: domainReducer,
  machines: machineReducer,
  transactionRequest: transactionRequestReducer,
  transactions: transactionReducer,
  bids: transactionBidsReducer,
  paymentType: transactionPaymentReducer,
  businessActivities: businessActivitiesReducer,
  loadingValue: loadingReducer,
  userDetails: userDetailsReducer,
  relatedAccount: relatedAccountReducer,
  dealerAccount: dealerAccountDetailsReducer,
  paymentMethod: paymentMethodReducer,
  selectedAccordion: selectedAccordionReducer,
  onSubmitDetails: onSubmitDetailsReducer,
  createTransactionResponse: createTransactionResponseObjReducer,
  isSimulateMode: simulateModeReducer,
  simulatedBusinessActivities: simulatedActivitiesReducer,
  simulatedUserDetails: simulatedUserDetailsReducer,
  searchTransactionResponse: searchTxnResponseReducer,
  actionType: actionTypeReducer,
  searchTxnAccountDropdowns: setSearchTxnAccountDropdownReducer,
  searchObj: searchObjReducer,
  txnsForReviewCount: txnsForReviewCountReducer,
  translatedTexts: translatedTextsReducer,
  searchPageComponents: setSearchPageComponentReducer,
  transactionAttachments: transactionAttachmentsReducer,
  transactionAttachmentResponse:transactionAttachmentResponseReducer,
  transactionStatus:transactionStatusReducer
});
